import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
};

export const EmptyState = ({ icon, title, description, action, className }: EmptyStateProps) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center',
      className,
    )}
  >
    {icon && <div className="text-ink-faint">{icon}</div>}
    <h3 className="text-base font-semibold text-ink-soft">{title}</h3>
    {description && <p className="max-w-sm text-sm text-ink-muted">{description}</p>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);
